import Vue from "vue";
import optional from "./Optional";
import {date_format} from "./DateTimeHelper";

const settings = window.settings || {};

export const getThousandSeparator = () => {
    return settings.thousand_separator ? settings.thousand_separator : ' ';
}

export const getDecimalSeparator = () => {
    return settings.decimal_separator ? settings.decimal_separator : '.';
}

export const getNumberOfDecimal = () => {
    return settings.number_of_decimal ? settings.number_of_decimal : 0
}

export const numberFormatter = number => {
    if (number && (String(number).indexOf('.') > -1)) {
        number = number.toFixed(getNumberOfDecimal())
    }
    if (!isNaN(parseFloat(number))) {
        let parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, getThousandSeparator());
        return parts.join(getDecimalSeparator());
    }
    return 0;
}

const toFiniteNumber = (value) => {
    const number = Number(value);

    return Number.isFinite(number) ? number : 0;
};

const toLocalizedNumber = (value) => {
    const [integerPart, decimalPart] = `${value}`.split('.');
    const normalizedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, getThousandSeparator());

    return decimalPart ? `${normalizedInteger}${getDecimalSeparator()}${decimalPart}` : normalizedInteger;
};

export const compactNumberFormatter = (value, maxDecimals = 2) => {
    const number = toFiniteNumber(value);
    const normalizedDecimals = Number.isFinite(Number(maxDecimals)) ? Math.max(Number(maxDecimals), 0) : 2;
    const fixed = number.toFixed(normalizedDecimals).replace(/\.?0+$/, '');

    return toLocalizedNumber(fixed);
};

export const countFormatter = (value, maxDecimals = 2) => {
    const number = toFiniteNumber(value);

    if (Math.abs(number - Math.round(number)) < 0.000001) {
        return numberFormatter(Math.round(number));
    }

    return compactNumberFormatter(number, maxDecimals);
};

export const percentFormatter = (value, maxDecimals = 2) => compactNumberFormatter(value, maxDecimals);

export const configFormatter = (format) => {
    return {
        id: format,
        value: Vue.prototype.$t(format)
    }
};

export const formatCurrency = (amount) => {
    return Vue.prototype.$t(`format_${optional(settings, 'currency_position')}`,
        {
            symbol: optional(settings, 'currency_symbol'),
            amount: amount
        })
}

